module.exports = __webpack_public_path__ + "static/img/womanonstairs.fb89e49.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/womanonstairs.png
// module id = 857
// module chunks = 0